import { A11yModule } from '@angular/cdk/a11y'
import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, inject, input, TemplateRef } from '@angular/core'
import { DrawerPosition, DrawerService } from './drawer.service'

export interface DrawerContext {
  $implicit: {
    close: () => void
  }
}

/**
 * This component is a container for overlay content handled by the drawer service. It should
 * not be used on its own.
 */
@Component({
  selector: 'ftr-drawer',
  template: `<div cdkTrapFocus cdkTrapFocusAutoCapture="true">
    <ng-container *ngTemplateOutlet="content(); context: drawerContext" />
  </div>`,
  styleUrl: './drawer.component.css',
  host: {
    '[id]': 'id()',
    '[attr.aria-modal]': 'true',
    '[attr.role]': '"dialog"',
    '[class]': 'hostClasses()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [A11yModule, NgTemplateOutlet],
})
export class DrawerOutlet {
  private readonly drawerService = inject(DrawerService)

  readonly id = input.required<string>()
  readonly content = input.required<TemplateRef<any>>()
  readonly position = input.required<DrawerPosition>()

  protected readonly hostClasses = computed<string>(() => {
    const position = this.position()
    return `drawer drawer--${position}`
  })

  protected readonly drawerContext: DrawerContext = {
    $implicit: {
      close: () => this.drawerService.close(),
    },
  }
}
